export default {
    totals: 'Totales',
    grand_total: 'Total General',
    work_type: 'Actividades',
    quantity: 'Cantidad',
    total_time: 'Tiempo total',
    call: {
        category: 'Categoria',
        total_ticket: 'Tickets totales',
        total_worklload: 'Cargas de trabajo totales',
    },
}
